import styled from 'styled-components';
import {
  Card,
  Dimmer,
  Table as SemanticTable,
} from 'semantic-ui-react';

import { Header as HeaderLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(Dimmer)``;

export const Dialog = styled(Card)`
  &.ui.card {
    display: flex;
    padding: 30px;
    width: 800px;
    background-color: ${({ theme }) => theme.background};
    border-radius: 1px;
    justify-content: space-between;

    :after {
      display: none;
    }
  }
`;

export const Text = styled(TextLayoutComponent)``;

export const Header = styled(HeaderLayoutComponent)`
  text-align: left;
`;

export const Content = styled.div`
  height: 600px;
`;

export const TableHeader = styled(SemanticTable.HeaderCell)`
  &&&& {
    z-index: 5;
    position: sticky;
    top: 0;
    font-size: 16px;
    background-color: white;
    font-weight: 500;
  }
`;

export const Table = styled(SemanticTable)`
  &.ui.fixed.table td {
    overflow:unset;
    overflow-x:clip;
  }
`;

export const ContainerTable = styled.div`
  display: flex;
  position: relative;
  overflow-y: auto;
  max-height: 600px;
  margin-top: 20px;
  padding: 0 20px 20px 0;
`;
